import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    territories: [],
    page: 1,
    page_size: 10,
    order_column: 'downloads',
    order_type: 'desc'
  },

  mutations: {
    setTerritories(state, payload) {
      state.territories = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    readTerritories({ commit, state }, filters = null) {

      let ls = localStorage.getItem('territories_filter')
      filters = JSON.parse(ls)

      commit('setLoading', true)
      axios.admin
        .get('report/territories', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setTerritories', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  },

  getters: {}
}
